'use strict';
import * as $j_java$002elang$002e$002dObject from "./java.lang.-Object.js";
import * as $j_samples$002e$002dPerson from "./samples.-Person.js";
var $p;
/** @constructor */
function $c_Lsamples_Person$() {
  this.Lq = null;
  $n_Lsamples_Person$ = this;
  this.Lq = ($m_Lsamples_Person$(), new $j_samples$002e$002dPerson.$c_Lsamples_Person("John", "Doe", 16, $j_java$002elang$002e$002dObject.$m_s_None$(), $j_java$002elang$002e$002dObject.$m_s_None$()));
}
export { $c_Lsamples_Person$ as $c_Lsamples_Person$ };
$p = $c_Lsamples_Person$.prototype = new $j_java$002elang$002e$002dObject.$h_O();
$p.constructor = $c_Lsamples_Person$;
/** @constructor */
function $h_Lsamples_Person$() {
}
export { $h_Lsamples_Person$ as $h_Lsamples_Person$ };
$h_Lsamples_Person$.prototype = $p;
$p.Uy = (function(x$0) {
  return new $j_samples$002e$002dPerson.$c_Lsamples_Person(x$0.g(0), x$0.g(1), (x$0.g(2) | 0), x$0.g(3), x$0.g(4));
});
$p.y = (function(p) {
  return this.Uy(p);
});
var $d_Lsamples_Person$ = new $j_java$002elang$002e$002dObject.$TypeData().i($c_Lsamples_Person$, "samples.Person$", ({
  pv: 1,
  e: 1,
  g: 1
}));
export { $d_Lsamples_Person$ as $d_Lsamples_Person$ };
var $n_Lsamples_Person$;
function $m_Lsamples_Person$() {
  if ((!$n_Lsamples_Person$)) {
    $n_Lsamples_Person$ = new $c_Lsamples_Person$();
  }
  return $n_Lsamples_Person$;
}
export { $m_Lsamples_Person$ as $m_Lsamples_Person$ };
